<template>
    <BasicDrawer :duration="duration / 1000" ref="basicDrawerRef" v-if="show">
        <template v-slot:header>
            <div class="cancel-button" @click="closeDrawer">取消</div>

            <div class="header-title">
                <div class="title-label">按省市选择</div>
            </div>

            <div class="confirm-button" @click="confirm">完成({{ checkAddress.length }}/200)</div>
        </template>

        <template>
            <div class="province-box">
                <div class="province-box_left">
                    <div
                        :class="['province-item', { 'is-check': currentProvince === item.code }]"
                        v-for="item in addressList"
                        :key="item.code"
                        @click="currentProvince = item.code"
                    >
                        {{ item.name }}

                        <div class="check-count" v-if="getCheckCount(item) > 0">{{ getCheckCount(item) }}</div>
                    </div>
                </div>

                <div class="province-box_right">
                    <div :class="['all-check', { 'is-check': isAllCheck }]" @click="handleAllCheck">
                        <div class="check-icon"><i class="iconfont">&#xe63b;</i></div>
                        <span>全选</span>
                    </div>

                    <div class="city-list">
                        <div
                            :class="['city-item', { 'is-check': checkAddress.includes(item.code) }]"
                            v-for="item in getCityList"
                            :key="item.code"
                            @click="handleCheckCity(item)"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </BasicDrawer>
</template>

<script>
import pc from "@/utils/training-data/pc.json";
import BasicDrawer from "./BasicDrawer.vue";

export default {
    name: "TimeChangeDrawer",
    components: {
        BasicDrawer,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        checkList: {
            type: Array,
            required: true,
        },
        duration: {
            type: Number,
            default: 200,
        },
    },
    data() {
        return {
            checkAddress: [],
            addressList: pc,
            currentProvince: pc[0].code,
        };
    },
    created() {},
    watch: {
        show(newVal) {
            if (newVal) {
                this.checkAddress = JSON.parse(JSON.stringify(this.checkList));
            }
        },
    },
    computed: {
        getCityList() {
            const provinceItem = this.addressList.find((item) => item.code === this.currentProvince);

            if (provinceItem) {
                return provinceItem.children || [];
            } else {
                return [];
            }
        },

        // 当前页是否全选
        isAllCheck() {
            return this.getCityList.every((item) => this.checkAddress.includes(item.code));
        },
    },
    methods: {
        // 选择城市
        handleCheckCity(city) {
            const cityIndex = this.checkAddress.findIndex((item) => item === city.code);

            if (cityIndex !== -1) {
                this.checkAddress.splice(cityIndex, 1);
            } else {
                if (this.checkAddress.length < 200) {
                    this.checkAddress.push(city.code);
                }
            }
        },

        // 全选和取消全选
        handleAllCheck() {
            if (this.isAllCheck) {
                // 取消全选
                this.getCityList.forEach((city) => {
                    const cityIndex = this.checkAddress.findIndex((item) => item === city.code);

                    if (cityIndex !== -1) this.checkAddress.splice(cityIndex, 1);
                });
            } else {
                // 全选
                this.getCityList.forEach((city) => {
                    const cityIndex = this.checkAddress.findIndex((item) => item === city.code);

                    if (cityIndex === -1 && this.checkAddress.length < 200) {
                        this.checkAddress.push(city.code);
                    }
                });
            }
        },

        // 该省市选中了多少
        getCheckCount(province) {
            const cityList = province.children || [];

            return (cityList.filter((city) => this.checkAddress.includes(city.code)) || []).length;
        },

        closeDrawer() {
            if (this.$refs.basicDrawerRef) {
                this.$refs.basicDrawerRef.hiddenDrawer();
            }

            setTimeout(() => {
                this.$emit("close");

                this.currentProvince = pc[0].code;
            }, this.duration);
        },

        confirm() {
            this.$emit("confirm", this.checkAddress);

            this.closeDrawer();
        },
    },
};
</script>

<style scoped lang="scss">
* {
    font-family: PingFang-SC;
}

::v-deep .drawer-box_header {
    font-size: 13px;
    color: #323233;
    font-weight: 600;

    .header-title {
        text-align: center;

        .title-tip {
            font-weight: 500;
            color: #999999;
            font-size: 12px;
            margin-top: 2px;
        }
    }

    .cancel-button,
    .confirm-button {
        width: 73px;
        cursor: pointer;
    }

    .confirm-button {
        color: #fc2b55;
        flex-shrink: 0;
        font-size: 13px;
        text-wrap: nowrap;
    }
}

::v-deep .drawer-box_content {
    padding: 0 !important;

    .province-box {
        height: 400px;
        display: flex;

        &_left {
            flex-shrink: 0;
            height: 100%;
            width: 80px;
            overflow: auto;
            border-right: 1px solid #f1f1f1;
            scrollbar-width: none;

            &::-webkit-scrollbar {
                display: none;
            }

            .province-item {
                padding: 12px 0 12px 12px;
                box-sizing: border-box;
                font-size: 12px;
                white-space: nowrap; /* 强制单行显示 */
                overflow: hidden; /* 超出部分隐藏 */
                text-overflow: ellipsis; /* 显示省略号 */
                position: relative;
                cursor: pointer;
                position: relative;

                &.is-check {
                    background-color: #f8f8f8;
                    color: #fc2b55;

                    &::before {
                        content: "";
                        position: absolute;
                        width: 2px;
                        background-color: #fc2b55;
                        left: 0;
                        top: 0;
                        bottom: 0;
                    }
                }

                .check-count {
                    position: absolute;
                    top: 5px;
                    right: 2px;
                    width: 16px;
                    height: 16px;
                    background-color: #fc2b55;
                    color: #ffffff;
                    font-size: 10px;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 16px;
                }
            }
        }

        &_right {
            flex-shrink: 0;
            height: 100%;
            width: calc(100% - 81px);
            overflow: auto;
            scrollbar-width: none;
            box-sizing: border-box;
            padding: 12px;

            &::-webkit-scrollbar {
                display: none;
            }

            .all-check {
                color: #8d8d8d;
                font-size: 13px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 4px;

                .check-icon {
                    border-radius: 50%;
                    width: 14px;
                    height: 14px;
                    border: 1px solid #dddddd;
                    display: flex;
                    align-items: center;

                    .iconfont {
                        background-color: #ffffff;
                        color: #fc2b55;
                        border-radius: 50%;
                        display: none;
                    }
                }

                &.is-check {
                    .iconfont {
                        display: block;
                    }
                }
            }

            .city-list {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                margin-top: 10px;

                .city-item {
                    width: calc((100% - 20px) / 3);
                    font-size: 12px;
                    border: 1px solid #f1f1f1;
                    border-radius: 2px;
                    box-sizing: border-box;
                    text-align: center;
                    padding-inline: 6px;
                    height: 26px;
                    line-height: 26px;
                    cursor: pointer;
                    white-space: nowrap; /* 强制单行显示 */
                    overflow: hidden; /* 超出部分隐藏 */
                    text-overflow: ellipsis; /* 显示省略号 */

                    &.is-check {
                        border-color: #fee3e8;
                        background-color: #fff3f5;
                        color: #fc2b55;
                    }
                }
            }
        }
    }
}
</style>
